import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../../../config/config.service';
import { Observable, throwError} from 'rxjs';
import { catchError } from 'rxjs/operators';
import { handleProblem } from '../../problems/problem.service';

@Injectable()
export class ReviewTaskFileGroupFilesService {
  constructor(private httpClient: HttpClient, private configService: ConfigService) {}

  public review(id: string): Observable<any> {
    const url: string = `${this.configService.config.rest.apiV2Url}/task-file-groups/${id}/set-files-reviewed`;

    return this.httpClient.post(url, {})
    .pipe(
      catchError(error => throwError(handleProblem(error)))
    );
  }
}
